export const infoUserDraftProject = 'infoUserDraftProject';
